module.exports = __webpack_public_path__ + "static/media/more-active.f50db86b.svg";